export const sidebar: SidebarMenu[] = [
  { section: 'main', text: 'Dashboard', href: '/', icon: 'dashboard' },
  { section: 'main', text: 'Production', href: '/productions', icon: 'panel-table' },
  { section: 'settings', text: 'Machines', href: '/machines', icon: 'cube' },
  { section: 'settings', text: 'Users', href: '/users', icon: 'user' },
];
